const HUBSPOT_ENABLED = true;
const HUBSPOT_PORTAL_ID = "148137356";
const HUBSPOT_REGION = "eu1";

const FORM_IDS = {
  wertermittlung: "e25bb339-bcc7-4b3c-9d19-e78eb3995922",
  verkauf:        "3f301248-a98b-4d26-be06-5aad028102fb",
  vermietung:     "bf49aefe-2ef5-441c-a637-d60b010f4804",
  vermittlung:    "e27d9915-5a2f-4797-91af-43337f01a6c1",
  expose:         "6731122b-10d0-4e96-b1e3-47e6e98860d2",

};

export async function submitLead(formType, formData) {
  if (!HUBSPOT_ENABLED) {
    console.log('[HubSpot] Disabled - would submit:', formType, formData);
    return { success: true };
  }

  const formId = FORM_IDS[formType];
  if (!formId) {
    console.error('[HubSpot] Unknown form type:', formType);
    return { success: false, error: 'Unknown form type' };
  }

  const fields = [
  { name: "firstname",        value: formData.name             || "" },
  { name: "email",            value: formData.email            || "" },
  { name: "phone",            value: formData.phone            || "" },
  { name: "message",          value: formData.message          || "" },
  { name: "property_type",    value: formData.propertyType     || "" },
  { name: "zip",              value: formData.zipCode          || "" },
  { name: "city",             value: formData.city             || "" },
  { name: "address",          value: formData.address          || "" },
  { name: "hs_lead_status",   value: "NEW"                          },
  { name: "service_interest", value: {
    wertermittlung: "Wertermittlung",
    verkauf:        "Verkauf",
    vermietung:     "Vermietung",
    vermittlung:    "Vermittlung",
    expose:         "Exposé-Anfrage",
  }[formType] || formType },
  { name: "living_area_sqm",  value: String(formData.livingArea || "") },
  { name: "property_title",    value: formData.propertyTitle  || "" },
  { name: "property_id",       value: formData.propertyId     || "" },
  { name: "preferred_contact", value: {
    phone:    "Telefon",
    email:    "E-Mail",
    whatsapp: "WhatsApp",
  }[formData.preferredContact] || formData.preferredContact || "" },
  { name: "construction_year", value: String(formData.buildingYear    || "") },
  { name: "amount_rooms",      value: String(formData.rooms           || "") },
  { name: "land_area_sqm",     value: String(formData.landArea        || "") },
  { name: "looking_for", value: formData.lookingFor || "" },
].filter(field => field.value !== "");

  try {
    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fields,
          context: {
            pageUri:  window.location.href,
            pageName: document.title,
          },
          legalConsentOptions: {
            consent: {
              consentToProcess: true,
              text: "Ich stimme der Verarbeitung meiner Daten gemäß der Datenschutzerklärung zu.",
            },
          },
        }),
      }
    );
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('[HubSpot] Submission failed:', errorData);
      return { success: false, error: errorData.message || 'Submission failed' };
    }
    
    console.log('[HubSpot] Submission successful for:', formType);
    return { success: true };
  } catch (err) {
    console.error('[HubSpot] Error:', err);
    return { success: false, error: err.message };
  }
}

export async function submitKontakt(formData) {
  const typeMap = {
    "Wertermittlung": "wertermittlung",
    "Verkauf":        "verkauf",
    "Vermietung":     "vermietung",
    "Vermittlung":    "vermittlung",
    "Sonstiges":      "wertermittlung",
  };
  return submitLead(typeMap[formData.subject] || "wertermittlung", formData);
}

export { HUBSPOT_ENABLED };
